import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';

export const getSalesChannel = async () => {
	const response = await api.get('/canalvenda');
	return response.data;
};
export const useSalesChannelList = () => {
	return useQuery(['salesChannel-list'], getSalesChannel, {
		refetchOnWindowFocus: false,
	});
};
